import { z } from 'zod';
import { requiredString } from '../helpers';
export const Snapsheet_Create_Claim_1_ConfigValidator = z.object({
    connectionId: requiredString('Snapsheet connection is required'),
    claimType: z.enum(['auto', 'property'], {
        error: (issue) => issue.input === undefined
            ? 'Claim type is required'
            : 'Claim type must be either "auto" or "property"'
    }),
    insuredVehicles: z.string().optional()
});
//# sourceMappingURL=snapsheet-create-claim-1.js.map